import {keys} from 'ts-transformer-keys';

// TODO: conditional type depending from valueType
//  VALUESET - schema : Schema, valueSetId : string, rawMode : boolean, showAdditionalRawNames : boolean, listingOrder : 'order' | 'asc' | 'desc'
//  DOUBLE | INTEGER - valueUnit? : string
//  TIMESTAMP - timezone : string
//  STATUS | STATUSID | STATUSNAME - schema : Schema, rawMode : boolean, showAdditionalRawNames : boolean
//  all other - none

export type FilterConfigSet = {
    schema? : Schema;
    timezone? : string;

    rawMode? : boolean;
    showAdditionalRawNames? : boolean;

    valueSetId? : number;

    valueUnit? : string;

    listingOrder? : 'order' | 'asc' | 'desc';
};
export type FilterConfig = false | FilterConfigSet;
export const filterConfig = keys<FilterConfigSet>();
